import { FC } from 'react';
import { useHistory } from 'react-router';
import { Image, VStack } from '@chakra-ui/react';

import ChillImage from 'assets/brand/chill.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import * as routes from '../../../../../../routes';
import locales from '../../../../locales';

const EmptyState: FC = () => {
  const history = useHistory();

  return (
    <VStack>
      <Image maxWidth="180px" src={ChillImage} />

      <Text fontWeight="weight-500" mt="space-24" size="lg">
        {locales.history.empty.title}
      </Text>

      <Text mt="space-16" size="lg">
        {locales.history.empty.subtitle}
      </Text>

      <Button
        icon="arrow-right"
        mt="space-32"
        onClick={() => history.push(routes.microEstimationFlow)}
        variant="primary"
      >
        {locales.history.empty.cta}
      </Button>
    </VStack>
  );
};

export default EmptyState;
